export default "__VITE_ASSET__69ac25a3__"